import React, { Component } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import "./ConversationStyleSheet.css";
import PreviewAttachmentFiles from "./PreviewAttachmentFiles";
import { debounce } from "lodash";
import ActivityIndicator from "../CommonUtils/ActivityIndicator";
import sendMsgImage from "../../images/send-message.svg";
import TextareaAutosize from "react-textarea-autosize";
import homeImage from "../../images/home.png";
import micro1 from "../../images/microphone_stop.png";
import micro2 from "../../images/microphone.png";
import { s360ConfigService } from "../Services/S360Config";
import gifImage from "../../images/gif.png";
import Picker from "emoji-picker-react";
import Popup from "./Popup";
import TextToSpeech from "./TextToSpeech";
import { isNullOrUndefined } from "../HWLibrary/HWUtils";

class InputBox extends Component {
  constructor(props) {
    super(props);
    //  this.messageRef = React.createRef();
    this.file = React.createRef();
    this.microphoneRef = React.createRef();
    this.state = {
      previewFiles: [],
      isLoading: false,
      showEmoji: false,
      height: 24,
      textValue:
        localStorage.getItem("finalvalue") !== null
          ? localStorage.getItem("finalvalue")
          : "",
      prevLen: [],
      showGif: false,
      sent: true,
      // isTyping:false,
    };
    //  this.gf = new GiphyFetch('gOpxLWVkXMDvot580AvBRoMXo4HngjxX');
  }

  componentDidMount() {
    if (!!s360ConfigService.URLParams?.text) {
      this.setState({ textValue: s360ConfigService.URLParams.text })
      this.props.setRef.current?.focus();
    }
  }

  // TODO: need remove if not working
  scrollConversationPage() {
    const convPage = document.getElementById("conver")?.firstChild

    if (convPage)
      convPage.scrollTo({
        top: convPage.scrollHeight,
        behavior: 'smooth'
      });
  }

  renderSendButton() {
    const isFullScreen = localStorage.getItem("openInFullScreen");

    return (
      <button
        className={
          isFullScreen
            ? "s360-new-conversation-tab-image1-fs"
            : "s360-new-conversation-tab-image1"
        }
        onClick={this.handleClick}
        aria-label="Send message"
      >
        {this.attachmentSVGImage(
          this.props.config.designDetails.selectionButtonsvgColor,
          this.props.config.designDetails.selectionButtonsvgWidth,
          this.props.config.designDetails.selectionButtonsvgHeight
        )}
      </button>
    )
  }

  renderHomeButton() {
    const fillColor = this.props.config.designDetails?.sendIconColor || "#000";
    return (
      <button
        className="s360-input-box-home"
        id="home"
        style={{ 
          borderRadius: `${this.props.config.designDetails?.inputBoxBorderRadius || 12}px`
        }}
        aria-label="Return to Main Menu"
        onClick={this.handleHomeClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke={fillColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ cursor: "pointer" }}
        >
          <path d="M3 12L12 3l9 9" />
          <path d="M5 10v9a1 1 0 001 1h4v-5h4v5h4a1 1 0 001-1v-9" />
        </svg>
      </button>
    );
  }

  renderMicrophoneButton() {
    const { disableInput } = this.props;
    const isFullScreen = localStorage.getItem("openInFullScreen");

    if (!this?.props?.config?.allowMicrophone) return null;

    return (
      <button
        className={
          isFullScreen
            ? "s360-new-conversation-tab-image1-fs"
            : "s360-new-conversation-tab-image1"
        }
        ref={this.microphoneRef}
        disabled={disableInput}
        aria-label="Voice input"
        style={{
          position: "absolute",
          right: "50px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: disableInput ? "not-allowed" : "pointer",
          opacity: disableInput ? 0.2 : 1,
          background: "transparent",
          border: "none",
          padding: 0,
          zIndex: 10,
        }}
      >
        <TextToSpeech
          showOutlinedMic
          style={{ height: "30px", width: "30px", bottom: "-6px" }}
          setTextValue={this.setTextValue}
          {...this.props}
          {...this.state}
        />
      </button>
    );
  }

  handleHomeClick = () => {
    const { config, onHome, resetChat } = this.props;

    if (typeof onHome === "function") {
      onHome();
      return;
    }

    if (config?.isHome && typeof this.props.sendMessage === "function") {
      const msg =
        config?.mainMenuMessage || "I would like to Return to main menu";
      this.props.sendMessage(msg);
      return;
    }

    if (typeof resetChat === "function") {
      resetChat();
    }
  };

  defaultMessage = this.props.disableInput
    ? "Not allowed while uploading documents."
    : "Type a message...";
  //kotak change
  keyWords = ["what", "when", "how", "why", "account"];
  render() {
    console.log(this.props.disableInput, "INPUT DISABLED HERE");
    const isFullScreen = localStorage.getItem("openInFullScreen");
    const { disableInput, showChatStatusAttachment } = this.props;
    
    return (
      <div>
        <div
          className={
            isFullScreen
              ? "s360-conversation-input-box-container-fs"
              : "s360-conversation-input-box-container"
          }
          style={{ height: "45px" }}
        >
          <div
            className={
              isFullScreen
                ? "s360-input-box-input-container-fs"
                : "s360-input-box-input-container"
            }
            id="tx"
            style={this.containerStyle()}
          >
            {this.props.config.configDetails?.showHomeInInputBox && this.renderHomeButton()}
            {/* <input ref={this.messageRef}  className="s360-input-box-input"  placeHolder={this.defaultMessage} onBlur={this.onInputOut} onClick={this.onClickInput} type="text" onChange={this.onTextFieldChange}  style={this.containerStyle()} onKeyPress={this.handleKeyPress} /> */}
            {/* <div className="s360-input-box-home" id="home" style={{marginBottom:"0px"}} onClick={this.refreshChat}>  
                        <img style={{ width: "20px", height: "20px", marginRight: "48px", marginLeft: "4px", cursor: "pointer" }} src={homeImage}  alt="/"></img>  
                        </div>
                        <div className="s360-input-box-emoji" id="emoji" style={{marginBottom:"0px"}} onClick={this.showEmoji}>   
                        {this.emojiSVGImage(this.props.config.designDetails.innerButtonSVGColor)}
                        </div>
                        <div>{this.state.showEmoji && <Picker onEmojiClick={this.onEmojiClick} groupVisibility={{flags: false,animals_nature:false,food_drink:false,travel_places:false,activities:false,objects:false,symbols:false}}
                                pickerStyle={{"position":"absolute","top":"-343px","left":"9px","width":"95%"}} />}</div>
                        
                        <div>{this.state.showGif && <Popup handleClose={this.handleClose} {...this.props}/>}</div>
                        <div className="s360-input-box-gif" id="gif" style={{marginBottom:"0px"}} onClick={this.showGIF}>  
                        <img style={{ width: "20px", height: "20px", marginRight: "48px", marginLeft: "4px", cursor: "pointer" }} src={gifImage}  alt="/"></img>  
                        </div> */}

            <TextareaAutosize
              disabled={disableInput}
              ref={this.props.setRef}
              id="tx1"
              value={this.state.textValue}
              className="s360-input-box-input"
              placeholder={this.defaultMessage}
              aria-label={this.defaultMessage || "Type your message"}
              type="text"
              onChange={this.onTextFieldChange}
              onBlur={this.handleTextFieldBlur}
              onFocus={this.handleTextFieldFocus}
              onKeyDown={this.handleKeyPress}
              style={{
                fontSize: this.props.config.designDetails?.inputFontSize || "14px",
                backgroundColor: "white",
                cursor: disableInput ? "not-allowed" : "default",
                opacity: disableInput ? 0.2 : 1,
              }}
            />

            {!s360ConfigService.config.configDetails?.toggleSendButton && SpeechRecognition.browserSupportsSpeechRecognition() && (
              <div
                className="s360-input-box-micro"
                ref={this.microphoneRef}
                id="gif"
                style={{
                  marginBottom: "0px",
                  cursor: disableInput ? "not-allowed" : "default",
                  opacity: disableInput ? 0.2 : 1,
                }}
              >
                {this?.props?.config?.allowMicrophone ? (
                  <TextToSpeech
                    setTextValue={this.setTextValue}
                    {...this.props}
                    {...this.state}
                  ></TextToSpeech>
                ) : null}
              </div>
            )}

            {/* <div className="s360-input-box-send" onClick={this.onMessageSend}>
                        {this.sendSVGImage(this.props.config.designDetails.innerButtonSVGColor)}
                    </div> */}
            <div
              disabled={false}
              className="s360-input-box-image-container"
              id="img2"
              style={{ marginBottom: "0px" }}
            >
              {showChatStatusAttachment && this.props.config.designDetails?.hideOptionsFooter && (
                <div
                  className={isFullScreen ? "s360-input-box-attachment-fs" : "s360-input-box-attachment"}
                  style={{ paddingRight: '10px', width: '30px' }}
                  onClick={() => this.file.current.click()}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); this.file.current.click(); } }}
                  role="button"
                  tabIndex={0}
                  aria-label="Attach file"
                >
                  <input
                    style={{ opacity: "0", width: "1px", display: "none" }}
                    ref={this.file}
                    type="file"
                    multiple="multiple"
                    aria-label="Attach file"
                    accept="image/*, video/*, audio/*, .doc,.docx, .pdf, .xls, .txt, .ppt, .xlsx, .csv,.ogg, .png, .ppt, .pptx, .rar, .tif, .tiff, .wav, .xls, .xlsx, .xps, .zip"
                    onChange={this.onFileSelect}
                    className="UploadFile image_uploader"
                  />
                  <img 
                    alt="attachment icon"
                    src={this.props.attachmentSVGImage(
                      !!this.props.config.designDetails.showPinStyleAttachmentIcon
                    )}
                  />
                </div>
              )}
              {s360ConfigService.config.configDetails?.toggleSendButton 
                ? this.state.textValue?.length > 0
                  ? this.renderSendButton()
                  : SpeechRecognition.browserSupportsSpeechRecognition() 
                    ? this.renderMicrophoneButton()
                    : this.renderSendButton()
                : this.renderSendButton()
              }
            </div>
          </div>
        </div>
        {this.state.previewFiles.length > 0 && (
          <PreviewAttachmentFiles
            {...this.props}
            {...this.state}
            onRemovePreviewFile={this.onRemovePreviewFile}
            onAddPreviewFile={this.onFileSelect}
            files={this.state.previewFiles}
          />
        )}
      </div>
    );
  }

  handleClick = () => {
    this.props.send();
    let check = !this.state.sent;
    this.setState({ textValue: "", sent: check }, () => {
      console.log(this.state.textValue);
    });
    localStorage.removeItem("finalvalue");
  };

  //    setTextValue = (bool) =>{
  //       this.setState({:})   ;

  //    }

  // handleClose = () =>{
  //     this.setState({showGif:false})

  // }

  // showGIF = () =>{
  //     let check = !this.state.showGif;
  //     this.setState({showGif:check})
  //     if(this.state.showEmoji === true)
  //     { this.setState({showEmoji:false})}
  // }

  // refreshChat = () =>{
  //     //   this.props.closeConversation();
  //     // this.props.closeConversationClick();
  //     // this.props.startNewConversation();
  //     this.setState({showGif:false});
  //     this.props.resetChat();
  // }

  // onEmojiClick = (event, emojiObject) => {
  //    const ref =  this.messageRef.current;
  //     ref.focus();

  //     const start = ref.value.substring(0,ref.selectionStart);
  //     const end = ref.value.substring(ref.selectionStart);
  //     const txt = start + emojiObject.emoji + end;
  //     ref.value = txt;
  //   }

  // showEmoji = () =>
  // {
  //     let chk = (this.state.showEmoji)?false:true
  //     this.setState({showEmoji: chk});
  //     if(chk ==  true && this.state.showGif === true )
  //     { this.setState({showGif:false})}
  // }
  containerStyle = () => {
    const styles = {
      borderColor: isNullOrUndefined(
        this.props.config.designDetails.inputBorderColor
      )
        ? "#ccc"
        : this.props.config.designDetails.inputBorderColor,
      color: isNullOrUndefined(this.props.config.designDetails.inputTextColor)
        ? "black"
        : this.props.config.designDetails.inputTextColor,
      backgroundColor: this.props.config.designDetails.pageBackgroundColor,
      // opacity: this.props.disableInput ? 0.2: 1 ,
      cursor: this.props.disableInput ? "not-allowed" : "text",
      //backgroundColor: "#FFFF00",
      // height:          "34px"
    };
    if (!isNullOrUndefined(this.props.config.designDetails.inputBoxBorderRadius)) {
      styles.borderRadius = `${this.props.config.designDetails.inputBoxBorderRadius}px`
    }

    return styles;
  };

  // onClickInput = (e) => {
  //     if (e.target.value === this.defaultMessage) { this.messageRef.current.value = ""; }
  // }

  // onInputOut = (e) => {
  //     if (!e.target.value || !e.target.value.trim) { this.messageRef.current.value = this.defaultMessage; }
  // }

  currentTypingStatus = false;

  // keyWordsListener =(val)=>{
  //     if(val=== "how"){
  //         alert("show card")

  //     }
  // }

  handleTextFieldBlur = () => {
    // publish typing status through cometD
    this.props.handleUpdateTypingStatus(false)
  }

  handleTextFieldFocus = (e) => {
    this.scrollConversationPage()
    
    // publish typing status through cometD
    if (e.target.value?.length > 0)
      this.props.handleUpdateTypingStatus(true)
  }

  onTextFieldChange = (e) => {
    // this.keyWordsListener(e.target.value);
    // if(this.keyWords.includes(e.target.value) )
    // {
    //     alert("faq")
    // }
    console.log("ccc...", e.target.value, this.props.setRef);
    this.setState({ textValue: e.target.value }, () => {
      console.log(this.state.textValue);
    });
    if (this.currentTypingStatus === false) {
      // this.props.sendTypingStatus(true);
    }
    this.currentTypingStatus = true;

    // publish typing status through cometD
    if (e.target.value?.length > 0)
      this.props.handleUpdateTypingStatus(true)
    else
      this.props.handleUpdateTypingStatus(false)

    this.debouncedTextChange();
    //  var diff= document.getElementById('tx1').scrollHeight;

    // if(diff<300){
    // document.getElementById('tx').style.height  = 34 + diff + "px";
    // document.getElementById('tx1').style.height = diff + "px";
    // document.getElementById('img2').style.marginBottom = diff-30 + "px";
    // document.getElementById('emoji').style.marginBottom = diff-20 + "px";
    // document.getElementById('home').style.marginBottom = diff-20 + "px";
    // // document.getElementById('gif').style.marginBottom = diff-20 + "px";
    // }
    //   else{
    //     document.getElementById('tx1').style.overflowY="scroll"
    //     console.log("scroll");
    //   }

    // document.getElementById('tx1').style.overflowY = "scroll";

    //  document.getElementById('tx1').style.overflowY = "hidden"

    // this.setState({height:document.getElementById('tx1').scrollHeight})

    // if((document.getElementById('tx1').scrollHeight !== this.state.height) && document.getElementById('tx1').scrollHeight<200){
    //     //console.log("lls",document.getElementById('tx1').value.length);
    //     // console.log("scroll",document.getElementById('tx1').scrollHeight);
    //     // console.log("tx1",document.getElementById('tx1').style.height);
    //     // console.log("tx",document.getElementById('tx').style.height);

    //    // console.log("prev",this.state.height);

    // //    console.log("len",document.getElementById('tx1').value.length)
    // //    console.log("")
    // //    this.setState({prevLen: [...this.state.prevLen , document.getElementById('tx1').value.length] })
    //   // console.log("lenar",this.state.prevLen);

    //     var diff= document.getElementById('tx1').scrollHeight;//- this.state.height;

    //    console.log("diff",diff);

    //     document.getElementById('tx').style.height  = 100 + diff + "px";//(parseInt(document.getElementById('tx').style.height.replace(/px/,""))+diff) + "px";
    //     document.getElementById('tx1').style.height = 50 + diff + "px";//(parseInt(document.getElementById('tx1').style.height.replace(/px/,""))+diff) + "px";

    //     this.setState({height:document.getElementById('tx1').scrollHeight})
    //     // console.log("lenar",this.state.prevLen);
    //     document.getElementById('tx1').style.overflowY = "hidden";
    // }
    // else if((document.getElementById('tx1').scrollHeight !== this.state.height) && document.getElementById('tx1').scrollHeight>200)
    // {
    //     document.getElementById('tx1').style.overflowY = "auto";
    // }
  };
  setTextValue = (text) => {
    console.log("te..", text, this.props.setRef);
    this.setState({ textValue: text });
  };

  debouncedTextChange = debounce(() => {
    console.log("ggg..");
    if (this.currentTypingStatus === true) {
      // this.props.sendTypingStatus(false);
    }
    this.currentTypingStatus = false;
  }, 1000);

  handleKeyPress = (event) => {
    console.log("key", event.key);
    console.log("isCheckedn", document.getElementById("newLine").checked);
    console.log("isCheckedc", document.getElementById("sendIt").checked);
    let forNewLine = document.getElementById("newLine").checked;
    let forSendMeg = document.getElementById("sendIt").checked;
    // cmd+ enter or
    if (
      (event.metaKey ||
        event.ctrlKey ||
        document.getElementById("newLine").checked) &&
      event.key === "Enter"
    ) {
      //+"\r\n";
      console.log("llc.", document.getElementById("newLine").checked);

      event.preventDefault();
      let value = this.state.textValue + "\r\n";
      this.setState({ textValue: value });
    }

    if (
      event.key === "Enter" &&
      !(event.metaKey || event.ctrlKey) &&
      document.getElementById("sendIt").checked
    ) {
      console.log("isChecked", document.getElementById("sendIt").value);
      event.preventDefault();
      this.props.send();
      let check = !this.state.sent;
      this.setState({ textValue: "", sent: check }, () => {
        console.log(this.state.textValue);
      });
      console.log("key", event.key);
    }

    if (!forSendMeg && !forNewLine && event.key === "Enter") {
      event.preventDefault();
      this.props.send();
      let check = !this.state.sent;
      this.setState({ textValue: "", sent: check }, () => {
        console.log(this.state.textValue);
      });
      console.log("key", event.key);
    }
  };

  // MARK: On Send Button Click.
  // onMessageSend = () => {
  //     console.log("emoji");
  //     let isMediaAttached = (this.state.previewFiles || []).length !== 0;
  //     console.log("media",isMediaAttached)
  //     let hasTextMessage  = !(!this.messageRef.current.value || !this.messageRef.current.value.trim() || this.messageRef.current.value === this.defaultMessage);
  //     console.log("txt",hasTextMessage);
  //     if (!isMediaAttached && !hasTextMessage) { return }
  //     if (hasTextMessage && !isMediaAttached) {
  //         this.props.sendMessage(this.messageRef.current.value.trim());
  //     } else if (isMediaAttached) {
  //         console.log("emoji");
  //         let textMessage = hasTextMessage ? this.messageRef.current.value.trim() : null;
  //         this.setState({ isLoading: true }, () => {
  //             this.props.sendMessageWithAttachemnts(this.state.previewFiles, textMessage)
  //                       .finally(() => { this.setState({ isLoading: false, previewFiles: [] }); });
  //         });
  //     }
  //     this.messageRef.current.value = "";
  //     this.setState({showEmoji: false});

  //     document.getElementById('tx').style.height  = 34+"px";
  //     document.getElementById('tx1').style.height = 24 +"px";
  //     document.getElementById('img2').style.marginBottom = 0 + "px";
  //     document.getElementById('emoji').style.marginBottom = 0 + "px";
  //     document.getElementById('home').style.marginBottom = 0 + "px";

  // }

  //MARK: Attachments
  // onFileSelect = (e) => {
  //     if (e.target.files) {
  //         const filesToUpload = [];
  //         let files = e.target.files;
  //         for (var i = 0; i < files.length; i++) { filesToUpload.push(files[i]); }
  //         if (filesToUpload.length === 0) { return }
  //         this.setState({ previewFiles: filesToUpload });
  //     }
  // }

  attachmentSVGImage = (imageColor, width, height) => {
    // return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
    //     width={width || "100%"} height={height || "100%"}
    //     viewBox="0 0 172 172"
    //     style={{ fill: imageColor }}><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill={imageColor}><path d="M86,14.33333c-39.5815,0 -71.66667,32.08517 -71.66667,71.66667c0,39.5815 32.08517,71.66667 71.66667,71.66667c39.5815,0 71.66667,-32.08517 71.66667,-71.66667c0,-39.5815 -32.08517,-71.66667 -71.66667,-71.66667zM121.83333,93.16667h-28.66667v28.66667h-14.33333v-28.66667h-28.66667v-14.33333h28.66667v-28.66667h14.33333v28.66667h28.66667z"></path></g></g></svg>

    //  return <svg focusable="false" aria-hidden="true" x="0px" y="0px" viewBox="0 0 15 16" width={width || "100%"} height={height || "100%"} style={{ fill: imageColor }} ><g transform="translate(-24.000000, -12.000000)"><path d="M25.4036262,27.3409362 C24.4176893,27.8509036 23.8195834,27.3951055 24.0683403,26.3201996 L25.0887779,21.910776 C25.2131242,21.3734618 25.7510472,20.8884231 26.3078778,20.8254187 L32.503417,20.1244045 C34.151155,19.9379658 34.1569707,19.6389088 32.503417,19.4549971 L26.3078778,18.7659164 C25.7589338,18.7048617 25.2129433,18.217839 25.0887779,17.6798715 L24.0683403,13.2586546 C23.8198614,12.1820783 24.408944,11.7182276 25.4036262,12.2327184 L38.22304,18.8634497 C39.208977,19.373417 39.2177223,20.1957141 38.22304,20.7102049 L25.4036262,27.3409362 Z"></path></g></svg>

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="38"
        height="38"
        viewBox="0 0 38 38"
        marginTop="-1rem"
      >
        <g id="send-message" transform="translate(-384 -15.195)">
          <circle
            id="Ellipse_46"
            data-name="Ellipse 46"
            cx="19"
            cy="19"
            r="19"
            transform="translate(384 15.195)"
            fill={
              !!this.props.config.designDetails.sendIconColor
                ? this.props.config.designDetails.sendIconColor
                : "#000"
            }
          />
          <g
            id="Group_40"
            data-name="Group 40"
            transform="translate(396.076 25.766)"
          >
            <path
              id="Vector_90"
              data-name="Vector 90"
              d="M1.7,17.223A2.476,2.476,0,0,1-.264,16.23a2.419,2.419,0,0,1-.385-2.147l1.7-5.847L-.649,2.39A2.419,2.419,0,0,1-.264.243,2.476,2.476,0,0,1,1.7-.75a2.429,2.429,0,0,1,1.182.309L14.759,6.09a2.45,2.45,0,0,1,0,4.293L2.884,16.914A2.429,2.429,0,0,1,1.7,17.223ZM1.7.75a.969.969,0,0,0-.767.393.919.919,0,0,0-.144.827L2.614,8.236.791,14.5a.919.919,0,0,0,.144.827.969.969,0,0,0,.767.393.946.946,0,0,0,.459-.123L14.036,9.069a.95.95,0,0,0,0-1.665L2.161.873A.946.946,0,0,0,1.7.75Z"
              fill="#fff"
            />
            <path
              id="Vector_90-2"
              data-name="Vector 90"
              d="M7.651,8.986H1.833a.75.75,0,0,1,0-1.5H7.651a.75.75,0,0,1,0,1.5Z"
              fill="#fff"
            />
          </g>
        </g>
      </svg>
    );
  };

  // emojiSVGImage = (imageColor, width, height) => {
  //     // return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
  //     //     // width={width || "100%"} height={height || "100%"}
  //     //     viewBox="0 0 172 172"
  //     //     style={{ fill: imageColor }}><g transform="translate(-17.2,-17.2) scale(1.2,1.2)"><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill={imageColor}><path d="M61.2965,154.06183c-11.11908,0 -22.24175,-4.2355 -30.702,-12.71008c-16.84883,-16.8775 -15.90642,-45.39008 0.95675,-62.25325l50.61817,-50.61817c5.96267,-5.96267 13.7815,-9.97242 22.19875,-10.49558c9.67142,-0.602 18.86625,2.88817 25.64233,9.67142c6.78325,6.77967 10.27342,15.9745 9.67142,25.64233c-0.52317,8.41367 -4.5365,16.23608 -10.49558,22.19875l-49.708,49.708c-4.00617,4.00617 -9.20558,6.79042 -14.84575,7.28492c-6.95167,0.60917 -13.588,-1.82033 -18.44342,-6.67933c-4.859,-4.85542 -7.2885,-11.49175 -6.67933,-18.44342c0.4945,-5.64017 3.27875,-10.84317 7.28492,-14.84575l34.64725,-34.64367c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-34.93033,34.93033c-1.85258,1.85258 -3.27158,4.17458 -3.73383,6.75458c-0.74533,4.14233 0.54108,8.17717 3.41492,11.051c4.66908,4.66908 12.80325,4.67625 17.48308,0l51.13775,-51.13775c4.24625,-4.257 6.58617,-9.90433 6.58617,-15.91358c0,-6.00925 -2.33992,-11.66017 -6.58975,-15.90642c-4.24983,-4.24625 -9.90075,-6.58975 -15.90642,-6.58975c-6.00567,0 -11.65658,2.33992 -15.90642,6.58975l-52.374,52.37042c-12.72083,12.72442 -12.72083,33.42533 0,46.14975c12.728,12.72083 33.42892,12.71725 46.14975,0l50.79733,-50.79733c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-50.79733,50.79733c-8.45308,8.45667 -19.565,12.685 -30.67692,12.685z"></path></g></g></g></svg>

  //     return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 22.341 22.341">
  //     <g id="Icon_feather-smile" data-name="Icon feather-smile" transform="translate(0.75 0.75)" opacity="0.85">
  //       <path id="Path_1" data-name="Path 1" d="M13.421,24.591a11.171,11.171,0,0,1-7.9-19.069,11.171,11.171,0,1,1,15.8,15.8A11.1,11.1,0,0,1,13.421,24.591Zm0-20.841a9.671,9.671,0,1,0,9.671,9.671A9.682,9.682,0,0,0,13.421,3.75Z" transform="translate(-3 -3)" fill="#4a6f8a"/>
  //       <path id="Path_2" data-name="Path 2" d="M16.168,23.834A6.361,6.361,0,0,1,11.4,21.45a.75.75,0,0,1,1.2-.9h0a4.915,4.915,0,0,0,3.57,1.787,4.852,4.852,0,0,0,3.568-1.784.75.75,0,0,1,1.2.9A6.361,6.361,0,0,1,16.168,23.834Z" transform="translate(-5.748 -8.495)" fill="#4a6f8a"/>
  //       <path id="Path_3" data-name="Path 3" d="M13.51,15H13.5a1.5,1.5,0,0,1,0-3h.01a1.5,1.5,0,0,1,0,3Z" transform="translate(-6.206 -6.206)" fill="#4a6f8a"/>
  //       <path id="Path_4" data-name="Path 4" d="M22.51,15H22.5a1.5,1.5,0,0,1,0-3h.01a1.5,1.5,0,0,1,0,3Z" transform="translate(-8.953 -6.206)" fill="#4a6f8a"/>
  //     </g>
  //   </svg>
  // }

  // sendSVGImage = (imageColor, width, height) => {
  //     // return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
  //     //     // width={width || "100%"} height={height || "100%"}
  //     //     viewBox="0 0 172 172"
  //     //     style={{ fill: imageColor }}><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g id="original-icon" fill={imageColor}><path d="M10.07813,10.16211l20.24024,65.08789h130.93164zM30.31836,86l-20.24024,65.0459l151.17188,-65.0459z"></path></g></g></svg>

  //     return <svg focusable="false" aria-hidden="true" x="0px" y="0px" viewBox="0 0 15 16" width="15px" height="16px" style={{ fill: imageColor }}><g transform="translate(-24.000000, -12.000000)"><path d="M25.4036262,27.3409362 C24.4176893,27.8509036 23.8195834,27.3951055 24.0683403,26.3201996 L25.0887779,21.910776 C25.2131242,21.3734618 25.7510472,20.8884231 26.3078778,20.8254187 L32.503417,20.1244045 C34.151155,19.9379658 34.1569707,19.6389088 32.503417,19.4549971 L26.3078778,18.7659164 C25.7589338,18.7048617 25.2129433,18.217839 25.0887779,17.6798715 L24.0683403,13.2586546 C23.8198614,12.1820783 24.408944,11.7182276 25.4036262,12.2327184 L38.22304,18.8634497 C39.208977,19.373417 39.2177223,20.1957141 38.22304,20.7102049 L25.4036262,27.3409362 Z"></path></g></svg>
  // }

  onFileSelect = (e) => {
    if (e.target.files) {
      const filesToUpload = [...this.state.previewFiles];
      let files = e.target.files;
      for (var i = 0; i < files.length; i++) {
        if (!filesToUpload.some(f => f.name === files[i].name)) {
          filesToUpload.push(files[i]);
        }
      }
      if (filesToUpload.length === 0) { return }
      this.setState({ previewFiles: filesToUpload });
    }
  }

  onRemovePreviewFile = (file) => {
    let previewFiles = this.state.previewFiles || [];
    previewFiles = previewFiles.filter(previewFile => previewFile.name !== file.name);
    this.setState({ previewFiles: previewFiles });
  }
}

export default InputBox;
